import React from "react";
import ReservationSegmentBuilderRoomTypeSelect from "../../ReservationSegmentBuilder/ReservationSegmentBuilderRoomTypeSelect";
import ReservationSegmentBuilderGuestTypes from "../../ReservationSegmentBuilder/steps/ReservationSegmentBuilderGuestTypes";
import ReservationsSegmentCheckInRoomSelect from "../../ReservationSegmentCheckIn/ReservationsSegmentCheckInRoomSelect";
import RateSelect from "../../Selects/RateSelect";
import DateHelper from "../../DateHelper/DateHelper";
import TimePickerInput from "../../TimePickerInput/TimePickerInput";
import I18n from "i18n-js";

class AccommodationSection extends React.Component {
  constructor(props) {
    super(props);
    this.onChangeRoom = this.onChangeRoom.bind(this);
    this.onChangeRoomType = this.onChangeRoomType.bind(this);
    this.onChangeRate = this.onChangeRate.bind(this);
  }

  render() {
    var room_label = I18n.t("room_identifier");
    var source = null;

    if (
      this.props.reservation_segment.check_in_check_out_time_source &&
      this.props.reservation_segment.check_in_check_out_time_source == "Rate"
    ) {
      source = "(Set in Rate)";
    } else if (
      this.props.reservation_segment.check_in_check_out_time_source &&
      this.props.reservation_segment.check_in_check_out_time_source ==
        "Reservation Setting"
    ) {
      source = "(Set by Property Setting)";
    } else if (
      this.props.reservation_segment.check_in_check_out_time_source &&
      this.props.reservation_segment.check_in_check_out_time_source ==
        "Override"
    ) {
      source = "(Overridden by Room)";
    }

    if (
      (this.props.reservation_segment &&
        this.props.reservation_segment.room_type.type_of_booking ==
          "room_group") ||
      (this.props.room_type &&
        this.props.room_type.type_of_booking == "room_group")
    ) {
      room_label = I18n.t("room_group_identifier") + "*";
    }

    return (
      <div>
        <div className="row spacer">
          <div className="col-sm-6">
            <label>{I18n.t("room_type")}</label>
            <br />
            {this.renderRoomType()}
          </div>
          <div className="col-sm-6">
            <label>{room_label}</label>
            <br />
            {this.renderRoom()}
          </div>
        </div>
        {this.props.reservation_segment.status != "held" ? (
          <div>
            <div className="row spacer">
              <div className="col-sm-6">
                <label>{I18n.t("rate") + "*"}</label>
                <br />
                {this.renderRates()}
              </div>
              <div className="col-sm-6">
                <ReservationSegmentBuilderGuestTypes {...this.props} />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <label>
                  {I18n.t("check_in_time")} {source}
                </label>

                <br />
                {!this.props.read_only ? (
                  <div>
                    <TimePickerInput
                      format={this.props.time_format}
                      selectedTime={
                        this.props.reservation_segment.check_in_time
                      }
                      onChange={this.props.onChangeCheckInTime}
                      offsetTime={false}
                    />
                  </div>
                ) : (
                  <div>
                    {
                      DateHelper.printDateToScreen(DateHelper.parseDate(this.props.reservation_segment.check_in_time), this.props.time_format)
                    }
                  </div>
                )}
              </div>
              <div className="col-sm-6">
                <label>
                  {I18n.t("check_out_time")} {source}
                </label>
                <br />
                {!this.props.read_only ? (
                  <div>
                    <TimePickerInput
                      format={this.props.time_format}
                      selectedTime={
                        this.props.reservation_segment.check_out_time
                      }
                      onChange={this.props.onChangeCheckOutTime}
                      offsetTime={false}
                    />
                  </div>
                ) : (
                  <div>
                    {
                      DateHelper.printDateToScreen(DateHelper.parseDate(this.props.reservation_segment.check_out_time), this.props.time_format)
                    }
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  renderStatusSelect() {
    return <div>{this.props.reservation_segment.status}</div>;
  }

  renderNumberOfGuests() {
    var self = this;
    var guest_types = [];

    if (
      this.props.guest_types &&
      this.props.reservation_segment &&
      this.props.reservation_segment.reservation_segment_guest_types
    ) {
      for (
        var i = 0,
          ilen =
            this.props.reservation_segment.reservation_segment_guest_types
              .length;
        i < ilen;
        i++
      ) {
        for (var j = 0, jlen = this.props.guest_types.length; j < jlen; j++) {
          if (
            this.props.reservation_segment.reservation_segment_guest_types[i]
              .guest_type_id == this.props.guest_types[j].id
          ) {
            guest_types.push(
              <tr key={this.props.guest_types[j].id}>
                <td>
                  {this.props.guest_types[j].name} (
                  {self.renderAgeRange(this.props.guest_types[j])})
                </td>
                <td className="text-right">
                  {
                    this.props.reservation_segment
                      .reservation_segment_guest_types[i].number_of_guests
                  }
                </td>
              </tr>
            );
          }
        }
      }
    }

    return (
      <div>
        <table className="table guest-types-table">
          <tbody>{guest_types}</tbody>
        </table>
      </div>
    );
  }

  renderAgeRange(guest_type) {
    if (
      guest_type.maximum_age == null ||
      typeof guest_type.maximum_age == "undefined"
    ) {
      return <span>{guest_type.minimum_age}+</span>;
    } else {
      return (
        <span>
          {guest_type.minimum_age} &ndash; {guest_type.maximum_age}
        </span>
      );
    }
  }

  renderRoom() {
    var identifier = I18n.t("not_assigned");
    var room = { id: "unassigned", identifier: I18n.t("not_assigned") };
    var onChange = this.props.onChangeRoom;

    if (this.props.reservation_segment.room) {
      identifier = this.props.reservation_segment.room.identifier;
      room = this.props.reservation_segment.room;
    } else if (this.props.reservation_segment.room_group) {
      identifier = this.props.reservation_segment.room_group.identifier;
      room = this.props.reservation_segment.room_group;
    }

    if (
      this.props.reservation_segment.room_type.type_of_booking == "room_group"
    ) {
      onChange = this.props.onChangeRoomGroup;
    }

    if (this.props.reservation_segment.parent_reservation_segment) {
      var parent_segment =
        this.props.reservation_segment.parent_reservation_segment;
      if (parent_segment.room && Object.keys(parent_segment.room).length) {
        var parent_segment_room = parent_segment.room.identifier;
        var moved_from = "moved_from_room";
      } else if (
        parent_segment.room_group &&
        Object.keys(parent_segment.room_group).length
      ) {
        var parent_segment_room = parent_segment.room_group.identifier;
        var moved_from = "moved_from_room_group";
      }
    }

    return (
      <div className="room">
        {!this.props.read_only ? (
          <div>
            <ReservationsSegmentCheckInRoomSelect
              room={room}
              room_type={this.props.reservation_segment.room_type}
              check_in_date={this.props.reservation_segment.check_in_date}
              check_out_date={this.props.reservation_segment.check_out_date}
              reservation_segment_id={this.props.reservation_segment.id}
              onChange={onChange}
              // selectorId={room.id}
              dateFormat={this.props.date_format}
              allowClear={true}
              source="ReservationBuilder"
            />
          </div>
        ) : (
          <div>{identifier}</div>
        )}
        {this.renderFieldErrors("room")}
        {this.props.reservation_segment.parent_reservation_segment ? (
          <div>*{I18n.t(moved_from) + " " + parent_segment_room}</div>
        ) : null}
      </div>
    );
  }

  renderRoomType() {
    
    return (
      <div className="room-type">
        {!this.props.read_only ? (
          <div>
            <ReservationSegmentBuilderRoomTypeSelect
              room_type={
                this.props.reservation_segment
                  ? this.props.reservation_segment.room_type
                  : this.props.room_type
              }
              daily_rental={this.props.daily_rental}
              onChange={this.props.onChangeRoomType}
            />
          </div>
        ) : (
          <div>
            {this.props.reservation_segment
              ? this.props.reservation_segment.room_type.name
              : this.props.room_type.name}
          </div>
        )}
      </div>
    );
  }

  renderRates() {
    var self = this;
    return (
      <div className="rate">
        {!this.props.read_only ? (
          <div>
            <RateSelect
              name="rate"
              start_date={this.props.reservation_segment.check_in_date}
              end_date={this.props.reservation_segment.check_out_date}
              rate={this.props.reservation_segment.rate}
              room_type={this.props.reservation_segment.room_type}
              onChange={self.props.onChangeRate}
            />
            {this.renderFieldErrors("rate")}

            {!this.props.reservation_segment.rate &&
            this.props.original_reservation_segment.rate ? (
              <div>
                <div style={{ fontStyle: "italic" }}>
                  *
                  {I18n.t("previous_rate") +
                  ":" +
                  " " +
                  this.props.original_reservation_segment.rate
                    ? this.props.original_reservation_segment.rate.code
                    : ""}
                </div>
              </div>
            ) : null}
          </div>
        ) : (
          <div>
            {self.props.reservation_segment.rate
              ? self.props.reservation_segment.rate.code
              : ""}
          </div>
        )}
      </div>
    );
  }

  onChangeRoom(room) {
    ReservationSegmentCardActions.changeRoom(room);
  }

  onChangeRate(event) {
    ReservationSegmentCardActions.changeRate(event.target.value);
  }

  onChangeRoomType(room_type) {
    if (
      room_type &&
      this.props.reservation_segment.room_type &&
      room_type.id != this.props.reservation_segment.room_type.id
    ) {
      ReservationSegmentCardActions.changeRoomType(room_type);
    }
  }

  renderFieldClasses(field, classnames) {
    var classname = classnames || "form-control";
    if (this.props.errors && this.props.errors.length) {
      classname = classname + " has-errors";
    }
    return classname;
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors.length) {
      var idx = 0;
      var errors = this.props.errors.map((error) => {
        idx = idx + 1;
        if (error.includes(field)) {
          return (
          <li key={idx}>
            <b>&#x2022;</b> {error}
          </li>
          )
        }
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    }
  }
}

export default AccommodationSection;
